import {Button, Col, Row} from "antd";
import React, {useEffect, useState} from "react";

import BackgroundImg from './background.png';
import {getWordpressUrl} from "@lib/wordpressVars";
import {PlusCircleOutlined} from '@ant-design/icons';
import {useWindowSize} from "@components/window-size-provider";

const SomethingMissing = () => {
    const {width} = useWindowSize();
    const [small, setSmall] = useState(width < 800);
    useEffect(() => {
        setSmall(width < 800);
    }, [width]);

    return (
        <Row className={"somethingMissing " + (small ? 'small' : '')} style={{backgroundImage: `url(${getWordpressUrl(BackgroundImg)})`}}>
            <Col span={small ? 24 : 16} className="colText">
                Let us know if something is incorrect or missing.
            </Col>
            <Col span={small ? 24 : 8} className="colButton">
                <a href="/add-comic/">
                    <Button icon={<PlusCircleOutlined />} size={small ? 'small' : 'large'} className="blueButton thickButton" >SUBMIT YOUR REQUEST</Button>
                </a>
            </Col>
        </Row>
    );
};

export default SomethingMissing;